import { Injectable, inject } from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {Observable, of, switchMap, take} from 'rxjs';
import { UserService } from './services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AdminUserGuard {
  constructor(private user: UserService, private router: Router) {}
  canActivate(): Observable<boolean> {
      return this.user.isAdmin$.pipe(
        take(1),
        switchMap((isAdmin) => {
          if (!isAdmin) {
            this.router.navigate(['/home']);
            return of(false);
          }
          return of(true);
        })
    );
  }
}


export const isAdminUser: CanActivateFn = () =>
  inject(AdminUserGuard).canActivate();
